import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import NavViews from '../../../stores/NavViews';
import { Popconfirm, message, Icon } from 'antd'
import { addLeaderboard } from '../../../api-calls/leaders';

@observer(["ViewStore", "UserStore", "CategoriesStore", "AuthStore", "CustomRouter"])
class ManageLeaders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            leaderboardName: "",
            numBetsWon: 0,
            userIdBetsWon: ""
        };

        this.handleLeaderboardNameChange = this.handleLeaderboardNameChange.bind(this);
        this.handleSubmitNewLeaderboard = this.handleSubmitNewLeaderboard.bind(this);
        this.handleNumBetsWonChange = this.handleNumBetsWonChange.bind(this);
        this.handleUserIdBetsWonChange = this.handleUserIdBetsWonChange.bind(this);
        this.handleBetsWonSubmit = this.handleBetsWonSubmit.bind(this);

    }

    async componentWillMount() {

    }

    handleLeaderboardNameChange(e) {
        this.setState({ leaderboardName: e.target.value });
    }

    handleSubmitNewLeaderboard() {
        let authToken = this.props.AuthStore.userAuth.auth.accessToken;
        if (this.state.leaderboardName == "") {
            message.warning("Leaderboard name cannot be blank!");
        } else {
            addLeaderboard(authToken, this.state.leaderboardName);
            message.info("Leaderboard submit!");
        }
    }

    handleNumBetsWonChange(e) {
        this.setState({numBetsWon: e.target.value});
    }

    handleUserIdBetsWonChange(e) {
        this.setState({userIdBetsWon: e.target.value});
    }

    handleBetsWonSubmit() {
        let authToken = this.props.AuthStore.userAuth.auth.accessToken;
        if (this.state.numBetsWon <= 0) {
            message.warning("Number of bets won must be greater than zero!");
        } else if (this.state.userIdBetsWon == "") {
            message.warning("Must have a user ID");
        } else {
           // updateLeaderboard(authToken, "bets won",  this.state.numBetsWon);
            message.info("Leaderboard submit!");
        }

    }







    render() {

        return (
            <div className="admin-wrap">
                <h2>Add a Leaderboard</h2>
                <div className="admin-form">
                    <div className="admin-form-field">
                        <div className="admin-form-field-title">Title: </div>
                        <input
                            type="text"
                            className="custom-input"
                            style={{ width: '60%' }}
                            placeholder="Leaderboard Name"
                            value={this.state.leaderboardName}
                            onChange={this.handleLeaderboardNameChange}
                        />
                        <div style={{ marginTop: '15px' }}>
                            <button onClick={this.handleSubmitNewLeaderboard} className="custom-btn-primary">Submit</button>
                        </div>
                    </div>
                </div>

                 <h2>Submit a Score</h2>

                 <h3>Bets Won</h3>
                 <div className="admin-form-field-title">Number of bets won: </div>
                        <input
                            type="text"
                            className="custom-input"
                            style={{ width: '60%' }}
                            placeholder="999"
                            value={this.state.numBetsWon}
                            onChange={this.handleNumBetsWonChange}
                        />
                         <div className="admin-form-field-title">User ID: </div>
                        <input
                            type="text"
                            className="custom-input"
                            style={{ width: '60%' }}
                            placeholder="5c11d60b0b77aa00043b516e"
                            value={this.state.userIdBetsWon}
                            onChange={this.handleUserIdBetsWonChange}
                           
                        />
                        <div style={{ marginTop: '15px' }}>
                            <button onClick={this.handleBetsWonSubmit} className="custom-btn-primary">Submit</button>
                        </div>


            </div>
        );
    }
}

export default ManageLeaders;


// WEBPACK FOOTER //
// ./src/components/appComponents/admin/ManageLeaders.js